var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,18.6h1v-3h-1v-0.5c0-0.3,0.2-0.5,0.5-0.5h1.5v1h3v-8h-3v1H30c-2.4,0.1-4.4,2.1-4.4,4.5v2.5h-1v3h0.9 c-0.3,2.3-2.1,4-4.4,4h-1c-2.3,0-4.2-1.7-4.5-4h1v-3h-1v-5h1v-3h-9v3h1v5h-1v3h1c0.2,4.4,2.9,8.3,7,10c0.8,0.7,1.5,1.6,2,2.6 c0.2,0.5-0.1,1.2-0.3,1.9c-0.2,0.7-0.8,2.2-0.1,3.2c0.3,0.7,1,1.1,1.8,1.1c0.8,0,1.6-0.4,2-1.1c0.3-0.8,0.4-1.7,0.1-2.5 c-0.3-1.5-0.6-3.1,1.1-4.3H23c0.7,0.3,1,0.6,1,1.1c-0.1,0.6,0.1,1.2,0.6,1.5l0.8,0.2l0.7-0.2c0.6-0.3,0.9-0.9,0.8-1.5V30 c-0.1-0.8,0.1-1.6,0.4-2.3C30.5,25.7,32.4,22.3,32.5,18.6z M26.5,13.1c0.1-1.9,1.6-3.4,3.5-3.5h4.5v4H33c-0.8,0-1.5,0.7-1.5,1.5v0.5 h-5V13.1z M9.6,10.6h5v5h-5V10.6z M20,34c0.1,0.7,0.3,1.4,0.1,1.7c-0.3,0.4-0.7,0.7-1.2,0.7c-0.4,0-0.8-0.3-1-0.7 c-0.4-0.6-0.1-1.4,0.2-2.3c0.4-0.8,0.5-1.7,0.3-2.5c-0.2-0.6-0.5-1.2-1-1.6l2.6,0.2h0.6C19.5,31,19.9,32.7,20,34z M26,29.9L26,29.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.1-0.4,0.1-0.6,0C25,31,25,30.8,25,30.6c0-0.6-0.2-1.2-0.7-1.6 c0.6-0.1,1.2-0.3,1.7-0.6C26,28.9,25.9,29.4,26,29.9z M21,28.5h-1.7l-0.7-1.7l2.6-1.3l-0.5-0.9L18.1,26l-1.8-0.9L15.9,26l1.8,0.9 l0.6,1.5c-4.9-0.8-8.5-4.9-8.7-9.8h5c0.3,2.8,2.6,5,5.5,5h1c2.8,0,5.2-2.2,5.4-5h5C31.2,24.2,26.6,28.6,21,28.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M20.7,29.5H20l-2.6-0.2c0.5,0.4,0.8,1,1,1.6c0.2,0.8,0.1,1.7-0.3,2.5c-0.3,0.9-0.6,1.7-0.2,2.3 c0.2,0.4,0.6,0.7,1,0.7c0.5,0,0.9-0.3,1.2-0.7c0.2-0.3,0-1-0.1-1.7C19.9,33.3,19.5,31,20.7,29.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M24.3,29c0.5,0.4,0.7,1,0.7,1.6c-0.1,0.2,0,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.6,0c0.2-0.1,0.3-0.4,0.3-0.6 c0-0.2-0.1-0.4-0.1-0.6l0,0c0-0.5,0-1,0.1-1.5C25.5,28.7,24.9,28.9,24.3,29z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M14.6,15.6v-5h-5v5H14.6z M12.6,11.6h1v3h-1V11.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M31.5,18.6h-5c-0.2,2.8-2.6,5-5.4,5h-1c-2.9,0-5.2-2.2-5.5-5h-5c0.2,4.9,3.8,9,8.7,9.8l-0.6-1.5L15.8,26 l0.4-0.9L18,26l2.7-1.4l0.5,0.9l-2.6,1.3l0.7,1.7H21C26.6,28.6,31.2,24.2,31.5,18.6z M12.6,19.6h1v1h-1V19.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M31.5,15.6v-0.5c0-0.8,0.7-1.5,1.5-1.5h1.5v-4H30c-1.9,0.1-3.4,1.6-3.5,3.5v2.5H31.5z M33,10.6v1h-1v-1H33z  M30,10.6h1v1h-1c-0.8,0-1.5,0.7-1.5,1.5v1h-1v-1C27.5,11.7,28.6,10.6,30,10.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M27.5,13.1v1h1v-1c0-0.8,0.7-1.5,1.5-1.5h1v-1h-1C28.6,10.6,27.5,11.7,27.5,13.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 11.6,
  fill: "#A1A1A1",
  width: 1,
  height: 3
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 19.6,
  fill: "#A1A1A1",
  width: 1,
  height: 1
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 10.6,
  fill: "#A1A1A1",
  width: 1,
  height: 1
});

function SvgLeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeak);
export default __webpack_public_path__ + "static/media/leak.8acd52e20201ea47fb66b78cac536279.svg";
export { ForwardRef as ReactComponent };